module.exports = __webpack_public_path__ + "img/BOX.9e0b6fdb.svg";